import Dimmer from 'mcs-toolkit/components/Dimmer';
import Progress from 'mcs-toolkit/components/Progress';
import React from 'react';
import { ProgressProps } from 'semantic-ui-react';

import styles from './ProgressBar.css';

export function ProgressBar({
    percent,
    progress = 'percent',
    ...props
}: ProgressProps) {
    return (
        <Dimmer className={styles.dimmer} inverted active={true}>
            <Progress
                className={styles.progress}
                percent={percent}
                active
                autoSuccess
                progress={progress}
                {...props}
            />
        </Dimmer>
    );
}
